import type { CartRepository } from '../../domain/repositories/CartRepository';

export class AddToCartUseCase {
  constructor(private repository: CartRepository) {}

  async execute(entityType: string, entityId: string, quantity: number = 1) {
    return await this.repository.addItem(entityType, entityId, quantity);
  }
}
